export enum AuthResult {
    Success = 'success',
    Cancel = 'cancel',
    Dismiss = 'dismiss',
    Opened = 'opened',
    Locked = 'locked',
    Error = 'error'
}
